import React, { PropsWithChildren } from 'react';

import { H1, Separator, VStack } from '@betterment/samba-react';

// Use border instead of background to avoid subpixel rendering issues
const BorderSeparator = () => (
  <Separator css={{ bg: 'transparent', borderTopWidth: '1px', borderTopStyle: 'solid', borderColor: 'border.weak' }} />
);

const DividedList: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <VStack
      css={{
        gap: 'space.300',
        '& > *:not(:first-child)': {
          paddingTop: 'space.300',
          borderTopWidth: 'thin',
          borderTopStyle: 'solid',
          borderColor: 'border.weak',
        },
      }}
    >
      {children}
    </VStack>
  );
};

const TaxImpactPreviewCardComponent: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <VStack
      css={{
        borderRadius: 'large',
        borderWidth: 'thin',
        borderStyle: 'solid',
        borderColor: 'border',
        padding: 'space.300',
        gap: 'space.300',
      }}
    >
      <H1 variant="title200">Tax and gain/loss preview</H1>
      <BorderSeparator />
      <VStack css={{ gap: 'space.300' }}>{children}</VStack>
    </VStack>
  );
};

export const TaxImpactPreviewCard = Object.assign(TaxImpactPreviewCardComponent, {
  DividedList,
});
